import React from 'react'
import PropTypes from 'prop-types'
import prettyBytes from 'pretty-bytes'
import { saveAs } from 'file-saver'
import { Button, ButtonGroup, Icon, Modal } from '@resurs/midas-react'
import { getText } from '../../../../internal/TextLabels'
import styles from './ExportUserModal.module.scss'

const ExportUserModal = ({ show, file, onClose }) => {
  const handleDownloadFile = () => {
    saveAs(file.url, file.filename)
    onClose?.()
  }

  return (
    <Modal
      title={getText('user.export.modal.title')}
      show={show}
      onClose={onClose}
      actions={
        <ButtonGroup>
          <Button type="link" onClick={onClose}>
            {getText('default.cancel')}
          </Button>
          <Button
            type="primary"
            kind="normal"
            disabled={!file}
            onClick={handleDownloadFile}
          >
            {getText('user.export.modal.save')}
          </Button>
        </ButtonGroup>
      }
    >
      <div className={styles.exportModalContainer}>
        {file ? (
          <div className={styles.file}>
            <Icon name="midasFileTable" />
            {file.filename} ({prettyBytes(file.size)})
          </div>
        ) : (
          <>
            {getText('user.export.modal.progress')} ...
            <div className={styles.progress} />
          </>
        )}
      </div>
    </Modal>
  )
}

ExportUserModal.propTypes = {
  show: PropTypes.bool,
  file: PropTypes.shape({
    url: PropTypes.string.isRequired,
    size: PropTypes.number.isRequired,
    filename: PropTypes.string.isRequired,
  }),
  onClose: PropTypes.func,
}

ExportUserModal.defaultProps = {
  show: false,
  file: null,
  onClose: () => undefined,
}

export default ExportUserModal
